import { RouteLocationNormalizedLoaded as Route } from 'vue-router';
import router from '@/router';
import openModal from '@/components/modal';

export function matches(route: Route): boolean {
  const { action, clientId } = route.query;
  return (action === 'showSocialAccounts' && clientId !== undefined);
}

async function showPopup(clientId: number) {
  const { default: component } = await import('./AccountsModal.vue');
  openModal(component, { clientId });
}

export function registerPopup() {
  router.beforeEach((to, from, next) => {
    next();
    if (matches(to)) {
      // @ts-ignore
      showPopup(to.query.clientId);
    }
  });
}
